<template>
  <div class="solution-content">
    <div class="common-title">
      <div class="common-title-content">
        方案概述
      </div>
    </div>
    <p class="solution-info">
      通过物联网、云计算、大数据等技术手段，建立社区立体化治安防控体系，提升社区治安防控能力。对社区各维度数据进行可视呈现，提供基于“人、房、车、事、物、情”等维度的数据专题分析，为基层政策的指挥决策、态势研判、管理机制优化提供重要依据。
    </p>
    <div class="solution-des">
      <img src="@/assets/images/solution/img_zhsq.png" />
    </div>
    <div class="solution-main-function">
      <div class="common-title">
        <div class="common-title-content">
          主要功能
        </div>
      </div>
      <div class="solution-main-show">
        <div class="show-item" v-for="(item, index) in iconList" :key="index">
          <img :src="item.iconSrc" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div class="solution-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="show-scene-list">
        <div class="item" v-for="(item, index) in imgList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhsq",
  data() {
    return {
      iconList: [
        {
          iconSrc: require("@/assets/images/solution/ico_sqaf.png"),
          text: "社区安防"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_xfjc.png"),
          text: "消防监测"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_fxyj.png"),
          text: "风险预警"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_sqfw.png"),
          text: "社区服务"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_xxfb.png"),
          text: "信息发布"
        }
      ],
      imgList: [
        {
          imgUrl: require("@/assets/images/solution/zafk.png"),
          text: "治安防控"
        },
        {
          imgUrl: require("@/assets/images/solution/zwhd.png"),
          text: "政务服务"
        },
        {
          imgUrl: require("@/assets/images/solution/zhyl.png"),
          text: "智慧养老"
        },
        {
          imgUrl: require("@/assets/images/solution/whhd.png"),
          text: "文化活动"
        }
      ]
    };
  }
};
</script>
